<template>
  <el-dialog
    title="打印"
    :visible.sync="dialogVisible"
    width="1200px"
    :before-close="handleClose"
  >
    <div id="print">
      <table class="gh-table">
        <!-- 固定表头部分 -->
        <thead>
          <!-- 门诊名称与处方笺标题合并为一行 -->
          <tr>
            <th colspan="24" style="padding: 0;">
              <span style="font-size: 18px;">{{ storeName }}</span>
              <span style="font-size: 16px; margin-left: 20px;">门诊处方笺</span>
            </th>
          </tr>
          <!-- 第一行：科别、费别、日期 -->
          <tr class="fixed-header" style="border-bottom: 1px solid #000;">
            <th colspan="2">科别</th>
            <th colspan="3">
              <el-input v-model="data.kebie" class="screen-only" />
              <span class="print-only">{{ data.kebie }}</span>
            </th>
            <th colspan="2">费别</th>
            <th colspan="3">
              <el-select v-model="data.feibie" style="width: 100px;" placeholder="请选择" class="screen-only">
                <el-option
                  v-for="item in feibieOptions"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                />
              </el-select>
              <span class="print-only">{{ data.feibie }}</span>
            </th>
            <th colspan="2" />
            <th colspan="2">{{ year }}</th>
            <th colspan="1">年</th>
            <th colspan="2">{{ month }}</th>
            <th colspan="1">月</th>
            <th colspan="2">{{ day }}</th>
            <th colspan="1">日</th>
            <th colspan="3" />
          </tr>
          <!-- 第二行：门诊号单独一行 -->
          <tr class="fixed-header" style="border-bottom: 1px solid #000;">
            <th colspan="3">门诊号</th>
            <th colspan="12">
              <el-input v-model="data.menzhenhao" class="screen-only" />
              <span class="print-only">{{ data.menzhenhao }}</span>
            </th>
            <th colspan="9" />
          </tr>
          <!-- 第三行：姓名、年龄、性别 -->
          <tr class="fixed-header" style="border-bottom: 1px solid #000;">
            <th colspan="2">姓名</th>
            <th colspan="5">{{ data.name }}</th>
            <th colspan="2">年龄</th>
            <th colspan="3">{{ data.age }}</th>
            <th colspan="1" />
            <th colspan="2">性别</th>
            <th colspan="1">{{ data.sexSign === '1' ? '√':'' }}</th>
            <th colspan="2">男</th>
            <th colspan="1">{{ data.sexSign === '1' ? '':'√' }}</th>
            <th colspan="2">女</th>
            <th colspan="3" />
          </tr>
          <!-- 第四行：临床诊断 -->
          <tr class="fixed-header" style="border-bottom: 1px solid #000;">
            <th colspan="4">临床诊断</th>
            <th colspan="20" />
          </tr>
        </thead>

        <!-- 表格内容 - 每行显示3个药品 -->
        <tbody class="prescription-body">
          <!-- 药品列表分组 -->
          <template v-for="(row, rowIndex) in groupedMedicines">
            <tr :key="'row-'+rowIndex">
              <template v-for="(item, itemIndex) in row">
                <td :key="'item-'+itemIndex" colspan="4" class="medicine-name">{{ item.materielName }}</td>
                <td :key="'item-'+itemIndex" colspan="2">{{ item.singleNum }}</td>
                <td :key="'item-'+itemIndex" colspan="2">g</td>
              </template>

              <!-- 填充空白位置 -->
              <template v-if="row.length < 3">
                <td v-for="n in (3 - row.length) * 8" :key="'empty-'+n" colspan="1" />
              </template>
            </tr>
          </template>

          <!-- 添加空行填充不足的高度 -->
          <template v-if="groupedMedicines.length < 4">
            <tr v-for="n in (4 - groupedMedicines.length)" :key="'empty-row-'+n">
              <td colspan="24">&nbsp;</td>
            </tr>
          </template>
        </tbody>

        <!-- 药品用量信息（已删除"分xx各一次"） -->
        <tr style="border-bottom: 1px solid #000;">
          <td colspan="6">
            {{ toJson(jsonStr.serveFeeSign,num.serveFeeSign) }}
          </td>
          <td colspan="6">
            {{ num.doseNum }}付
          </td>
          <td colspan="6">
            1日{{ num.dayFreq }}剂
          </td>
          <td colspan="6">
            1日{{ num.dayDoseNum }}次
          </td>
        </tr>

        <!-- 底部汇总 -->
        <tfoot>
          <tr>
            <td colspan="2">医师</td>
            <td colspan="6" style="border-bottom: 1px solid #000;" />
            <td colspan="2">审核</td>
            <td colspan="6" style="border-bottom: 1px solid #000;" />
            <td colspan="2">金额</td>
            <td colspan="6" style="border-bottom: 1px solid #000;">
              {{ diagRecord.paymentAmount.toFixed(2) }}元
            </td>
          </tr>
          <tr>
            <td colspan="2">调配</td>
            <td colspan="6" style="border-bottom: 1px solid #000;" />
            <td colspan="2">核对</td>
            <td colspan="6" style="border-bottom: 1px solid #000;" />
            <td colspan="2">发药</td>
            <td colspan="6" style="border-bottom: 1px solid #000;" />
          </tr>
        </tfoot>
      </table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handlePrint">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      dialogVisible: false,
      data: {
        kebie: '中医科',
        feibie: '自费',
        menzhenhao: ''
      },
      num: {},
      options: [
        { value: '早中晚' },
        { value: '中晚' },
        { value: '早中' },
        { value: '早晚' },
        { value: '早' },
        { value: '中' },
        { value: '晚' },
        { value: '睡前' }
      ],
      feibieOptions: [
        { value: '自费' }
      ],
      year: '',
      month: '',
      day: '',
      storeName: '',
      medicines: [],
      jsonStr: {
        positionSign: '[{"key": "1", "value": "药房"}, {"key": "2", "value": "药库"}]',
        classifySign: '[{"key": "1", "value": "中成药"}, {"key": "3", "value": "饮片"}, {"key": "5", "value": "产品"}]',
        qualitySign: '[{"key": "1", "value": "普通"}, {"key": "2", "value": "精品"}]',
        executeSign: '[{"key": "1", "value": "草稿"}, {"key": "2", "value": "完成"}]',
        sourceTypeSign: '[{"key": "1", "value": "采购"}, {"key": "2", "value": "盘点"}, {"key": "3", "value": "退货"}]',
        serveFeeSign: '[{"key": "00", "value": "不加工"},{"key": "01", "value": "代煎"}, {"key": "11", "value": "制粒"}, {"key": "21", "value": "细粉打粉"}, {"key": "22", "value": "粗粉打粉"}, {"key": "31", "value": "水丸制丸"}, {"key": "32", "value": "蜜丸制丸"}, {"key": "33", "value": "大蜜丸制丸"}, {"key": "34", "value": "浓缩丸制丸"}, {"key": "35", "value": "水蜜丸制丸"}, {"key": "41", "value": "制瓶装膏"}, {"key": "42", "value": "制袋装膏"}, {"key": "43", "value": "制块装膏"}]'

      },
      diagRecord: {}
    }
  },
  computed: {
    groupedMedicines() {
      if (!this.medicines || this.medicines.length === 0) {
        return []
      }
      const grouped = []
      for (let i = 0; i < this.medicines.length; i += 3) {
        grouped.push(this.medicines.slice(i, i + 3))
      }
      return grouped
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    open(data) {
      this.data = data.data

      this.medicines = data.body.chmedPrescriptionItemList
      this.num = data.body.chmedPrescription
      this.diagRecord = data.body.diagRecord
      const now = dayjs()
      this.year = now.year()
      this.month = now.month() + 1
      this.day = now.date()
      this.data.age = this.calculateAge(this.data.birthDate)
      this.storeName = JSON.parse(localStorage.getItem('user')).storeName
      this.data.kebie = '中医科'
      this.data.menzhenhao = data.body.chmedPrescriptionItemList[0].chmedPrescriptionCode || ''

      this.dialogVisible = true
    },
    toJson(jsonStr, value) {
      const json = JSON.parse(jsonStr)
      let data = ''
      json.forEach(element => {
        if (element.key === value) {
          data = element.value
        }
      })
      return data
    },
    handlePrint() {
      // 获取打印内容
      const printContent = document.getElementById('print').innerHTML

      // 创建打印窗口
      const printWindow = window.open('', '_blank', 'width=800,height=600')
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>处方打印</title>
            <style>
              /* 打印专用样式 */
              @media print {
                @page {
                  size: A5 portrait;
                  margin: 5mm;
                }
                body {
                  margin: 0;
                  padding: 5mm;
                  width: 100%;
                  font-size: 14px;
                  line-height: 1.6;
                }
                .print-container {
                  width: 100% !important;
                  max-width: 148mm;
                  margin: 0 auto;
                }
                table {
                  width: 100% !important;
                  border-collapse: collapse;
                  table-layout: fixed;
                  font-size: 14px !important;
                }
                th, td {
                  padding: 3px 4px !important;
                  word-break: break-word;
                  font-size: 14px !important;
                }

                /* 标题行字体控制 */
                .gh-table > thead > tr:first-child th {
                  padding: 3px 4px !important;
                }
                .gh-table > thead > tr:first-child th span:first-child {
                  font-size: 20px !important;
                  font-weight: bold;
                }
                .gh-table > thead > tr:first-child th span:nth-child(2) {
                  font-size: 16px !important;
                }

                /* 隐藏屏幕专用元素 */
                .screen-only {
                  display: none !important;
                }

                /* 显示打印专用元素 */
                .print-only {
                  display: inline !important;
                }

                /* 调整行高 */
                tr {
                  line-height: 1.8;
                }

                /* 确保表头在每页重复 */
                thead {
                  display: table-header-group;
                }

                /* 防止行内分页 */
                tr {
                  page-break-inside: avoid;
                }

                /* 内容区域高度自适应 */
                .prescription-body {
                  height: auto !important;
                }
              }

              /* 屏幕显示样式 */
              body {
                font-family: "Microsoft YaHei", sans-serif;
              }
              .gh-table {
                width: 100%;
                table-layout: fixed;
                border-collapse: collapse;
              }
              th, td {
                padding: 8px 4px;
                text-align: center;
              }
              .fixed-header {
                background-color: #f8f8f8;
              }
              .screen-only {
                display: inline-block;
              }
              .print-only {
                display: none;
              }
            </style>
          </head>
          <body>
            <div class="print-container">
              ${printContent}
            </div>
            <script>
              // 自动触发打印
              window.onload = function() {
                window.print();
                setTimeout(function() {
                  window.close();
                }, 300);
              }
            <\/script>
          </body>
        </html>
      `)
      printWindow.document.close()
    },
    calculateAge(birthDate) {
      const birth = dayjs(birthDate)
      const now = dayjs()

      let years = now.year() - birth.year()
      let months = now.month() - birth.month()
      let days = now.date() - birth.date()

      if (days < 0) {
        months -= 1
        days += dayjs(now).subtract(1, 'month').daysInMonth()
      }
      if (months < 0) {
        years -= 1
        months += 12
      }
      if (now.month() > birth.month()) {
        years += 1
      }
      if (years > 0) {
        return `${years}岁`
      } else {
        return `${months}月`
      }
    }
  }
}
</script>

<style scoped>
/* 添加全局表格样式 */
.gh-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: none;
  font-family: "Microsoft YaHei", sans-serif;
}

/* 修改：确保列宽生效 */
.gh-table th,
.gh-table td {
  word-break: break-all;
  padding: 8px 4px;
  border: none;
  font-size: 14px;
  text-align: center;
}

/* 默认情况下隐藏打印专用元素 */
.print-only {
  display: none;
}

/* 处方内容区域样式 */
.prescription-body {
  display: block;
  height: 350px;
  width: 540px;
  overflow-y: auto;
}

.prescription-body tr {
  vertical-align: top;
}

/* 添加打印样式 */
@media print {
  .fixed-header {
    display: table-header-group;
  }

  .gh-table {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* 确保表头在每页重复 */
  thead {
    display: table-header-group;
  }

  /* 防止行内分页 */
  tr {
    page-break-inside: avoid;
  }

  /* 重置打印边距 */
  body {
    margin: 0;
    padding: 5mm;
  }

  /* 隐藏屏幕专用元素 */
  .screen-only {
    display: none !important;
  }

  /* 显示打印专用元素 */
  .print-only {
    display: inline !important;
  }

  /* 内容区域高度自适应 */
  .prescription-body {
    height: auto !important;
    overflow: visible !important;
  }

  /* 调整行高 */
  tr {
    line-height: 1.8 !important;
  }
}

/* 非打印时的滚动条样式 */
@media screen {
  .prescription-body {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f0f0f0;
  }

  .prescription-body::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .prescription-body::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 3px;
  }

  .prescription-body::-webkit-scrollbar-track {
    background-color: #f0f0f0;
  }
}
</style>
